import React, { useContext } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
} from "react-pro-sidebar";
import {
  FaAngleDoubleLeft,
  FaAngleDoubleRight,
  FaBook,
  FaHandsHelping,
  FaUserCog,
  FaSignOutAlt,
  FaMoneyBill,
} from "react-icons/fa";
import { handleLogout } from "../constants/logoutHelper";

const Sidebar = ({
  collapsed,
  toggled,
  handleToggleSidebar,
  handleCollapsedChange,
}) => {
  const { user, setting, dispatch } = useContext(AuthContext);
  const navigate = useNavigate();

  const logoutButtonHandler = async (e) => {
    e.preventDefault();
    handleLogout(dispatch, navigate);
  };

  return (
    <ProSidebar
      collapsed={collapsed}
      toggled={toggled}
      onToggle={handleToggleSidebar}
      breakPoint="md"
    >
      {/* Header */}
      <SidebarHeader>
        <Menu iconShape="circle">
          {collapsed ? (
            <MenuItem
              icon={<FaAngleDoubleRight />}
              onClick={handleCollapsedChange}
            ></MenuItem>
          ) : (
            <MenuItem
              suffix={<FaAngleDoubleLeft />}
              onClick={handleCollapsedChange}
            >
              <div
                style={{
                  padding: "9px",
                  textTransform: "uppercase",
                  fontWeight: "bold",
                  fontSize: 15,
                  letterSpacing: "1px",
                }}
              >
                {setting.namaProgram} {setting.namaJenisProgram}
              </div>
            </MenuItem>
          )}
        </Menu>
      </SidebarHeader>
      {/* Content */}
      <SidebarContent>
        <Menu iconShape="circle">
          <SubMenu title={"Master"} icon={<FaBook />}>
            {user.akses.peserta === true && (
              <MenuItem>
                Peserta <NavLink to="/peserta" />
              </MenuItem>
            )}
            {/* {user.akses.cabang === true && (
              <MenuItem>
                Cabang <NavLink to="/cabang" />
              </MenuItem>
            )} */}
          </SubMenu>
          <SubMenu title={"Arisan"} icon={<FaHandsHelping />}>
            {user.akses.kelompok === true && (
              <MenuItem>
                Kelompok <NavLink to="/daftarKelompok" />
              </MenuItem>
            )}
            {user.akses.setoran === true && (
              <MenuItem>
                Setoran <NavLink to="/setoran" />
              </MenuItem>
            )}
            {user.akses.biaya === true && (
              <MenuItem>
                Biaya <NavLink to="/biaya" />
              </MenuItem>
            )}
          </SubMenu>
          <SubMenu title={"Lelang"} icon={<FaMoneyBill />}>
            {user.akses.lelangBulanan === true && (
              <MenuItem>
                Lelang Bulanan <NavLink to="/lelangBulanan" />
              </MenuItem>
            )}
            {user.akses.bid === true && (
              <MenuItem>
                Bid <NavLink to="/bid" />
              </MenuItem>
            )}
            {user.akses.penetapanPemenang === true && (
              <MenuItem>
                Penetapan Pemenang <NavLink to="/penetapanPemenang" />
              </MenuItem>
            )}
          </SubMenu>
          <SubMenu title={"Laporan"} icon={<FaUserCog />}>
            {user.akses.laporanPenerimaan === true && (
              <MenuItem>
                Laporan Penerimaan <NavLink to="/laporanPenerimaan" />
              </MenuItem>
            )}
            {user.akses.laporanBiaya === true && (
              <MenuItem>
                Laporan Biaya <NavLink to="/laporanBiaya" />
              </MenuItem>
            )}
            {user.akses.laporanPemenang === true && (
              <MenuItem>
                Laporan Pemenang Bid <NavLink to="/laporanPemenang" />
              </MenuItem>
            )}
            {user.akses.laporanKeuangan === true && (
              <MenuItem>
                Laporan Keuangan <NavLink to="/laporanKeuangan" />
              </MenuItem>
            )}
            {user.akses.laporanTunggakan === true && (
              <MenuItem>
                Laporan Tunggakan <NavLink to="/laporanTunggakan" />
              </MenuItem>
            )}
          </SubMenu>
          <SubMenu title={"Utility"} icon={<FaUserCog />}>
            {user.akses.profilUser === true && (
              <MenuItem>
                Profil User <NavLink to="/profilUser" />
              </MenuItem>
            )}
            {user.akses.daftarUser === true && (
              <MenuItem>
                Daftar User <NavLink to="/daftarUser" />
              </MenuItem>
            )}
            {user.akses.setting === true && (
              <MenuItem>
                Setting <NavLink to="/setting" />
              </MenuItem>
            )}
          </SubMenu>
        </Menu>
      </SidebarContent>
      {/* Footer */}
      <SidebarFooter style={{ textAlign: "center" }}>
        <p style={{ fontSize: "12px", marginTop: "10px" }}>{user.username}</p>
        <p
          style={{ fontSize: "12px", marginTop: "-10px" }}
        >{`${user.cabang.id} - ${user.cabang.namaCabang}`}</p>
        <div className="sidebar-btn-wrapper" style={{ paddingBottom: "10px" }}>
          <Link
            className="sidebar-btn"
            style={{ cursor: "pointer" }}
            to="/"
            onClick={logoutButtonHandler}
          >
            <span style={{ marginRight: "6px" }}>Logout</span>
            <FaSignOutAlt />
          </Link>
        </div>
      </SidebarFooter>
    </ProSidebar>
  );
};

export default Sidebar;
